
import React, { useState, useEffect, useRef } from 'react';
import { 
  Video, VideoOff, Mic, MicOff, Users, Send, MessageCircle, 
  Settings, Maximize2, Volume2, VolumeX, Heart, Smile, 
  Camera, Monitor, Phone, PhoneOff, Plus, X, Lock, 
  Unlock, Crown, Eye, EyeOff, Share2, Sparkles, Zap,
  TrendingUp, Clock, Star, Award, Gift, Leaf, Filter,
  Search, Hash, Globe, AlertCircle, CheckCircle, ChevronUp, ChevronDown, UserPlus, Check
} from 'lucide-react';
import API_URL from '../config/ApiUrl';
import { useTheme } from '../arrangement/ThemeContext';
export const PendingInvitationsModal = ({ isOpen, onClose, currentUser, onInvitationResponse }) => {
  const [invitedRooms, setInvitedRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingRoomId, setProcessingRoomId] = useState(null);
  const [error, setError] = useState(null);
  const { colors } = useTheme(); 

  useEffect(() => {
    if (isOpen) {
      fetchPendingInvitations();
    }
  }, [isOpen]);

  const fetchPendingInvitations = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/api/rooms?membership=invited`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setInvitedRooms(data.rooms || []);
      } else {
        setError('Failed to fetch pending invitations');
      }
    } catch (err) {
      console.error('Error fetching pending invitations:', err);
      setError('Failed to fetch pending invitations');
    } finally {
      setLoading(false);
    }
  };

  const handleInvitationAction = async (room, action) => {
    setProcessingRoomId(room.id);
    try {
        const endpoint = action === 'accept' ? 'accept-invitation' : 'decline-invitation';
        const response = await fetch(`${API_URL}/api/rooms/${room.id}/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
        });

        const data = await response.json();
        
        if (response.ok) {
        setInvitedRooms(prev => prev.filter(r => r.id !== room.id));
        
        if (onInvitationResponse) {
            onInvitationResponse({
            success: true,
            message: data.message || (action === 'accept' ? 'Invitation accepted!' : 'Invitation declined.'),
            action: action === 'accept' ? 'accepted' : 'declined',
            room: data.room || room
            });
        }
        } else {
        if (onInvitationResponse) {
            onInvitationResponse({
            success: false,
            message: data.error || `Failed to ${action} invitation`
            });
        }
        }
    } catch (error) {
        console.error(`Error ${action}ing invitation:`, error);
        if (onInvitationResponse) {
        onInvitationResponse({
            success: false,
            message: `Failed to ${action} invitation`
        });
        }
    } finally {
        setProcessingRoomId(null);
    }
    };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: colors.bgTertiary,
        borderRadius: '20px',
        border: '1px solid #333',
        width: '100%',
        maxWidth: '800px',
        maxHeight: '80vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          padding: '24px 32px',
          borderBottom: `1px solid ${colors.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#2a2a2a'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <UserPlus size={20} style={{ color: 'white' }} />
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#e5e5e5' }}>
                Pending Invitations
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#888' }}>
                {invitedRooms.length} room{invitedRooms.length !== 1 ? 's' : ''} waiting for your response
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              padding: '8px',
              background: 'transparent',
              border: 'none',
              color: '#888',
              cursor: 'pointer',
              borderRadius: '8px'
            }}
          >
            <X size={24} />
          </button>
        </div>

        <div style={{
          flex: 1,
          overflow: 'auto',
          padding: '24px'
        }}>
          {loading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '60px',
              color: '#888'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid #333',
                borderTop: '4px solid #8b5cf6',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginRight: '16px'
              }} />
              Loading invitations...
            </div>
          ) : error ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#ef4444'
            }}>
              <p>{error}</p>
              <button
                onClick={fetchPendingInvitations}
                style={{
                  padding: '8px 16px',
                  background: '#8b5cf6',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white',
                  cursor: 'pointer',
                  marginTop: '16px'
                }}
              >
                Try Again
              </button>
            </div>
          ) : invitedRooms.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '60px 20px',
              color: '#888'
            }}>
              <UserPlus size={48} style={{ marginBottom: '16px', opacity: 0.3 }} />
              <h3 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600' }}>
                No Pending Invitations
              </h3>
              <p style={{ margin: 0, fontSize: '14px' }}>
                You don't have any room invitations at the moment.
              </p>
            </div>
          ) : (
            <div style={{
              display: 'grid',
              gap: '16px'
            }}>
              {invitedRooms.map((room) => (
                <div key={room.id} style={{
                  background: colors.bgCard,
                  border: '1px solid #8b5cf6',
                  borderRadius: '16px',
                  padding: '20px',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '16px'
                  }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <h3 style={{
                          margin: 0,
                          fontSize: '18px',
                          fontWeight: '600',
                          color: '#e5e5e5'
                        }}>
                          {room.title}
                        </h3>
                        {room.is_live && (
                          <span style={{
                            padding: '4px 8px',
                            background: '#00d4aa',
                            borderRadius: '8px',
                            fontSize: '10px',
                            fontWeight: '600',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}>
                            <div style={{
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              background: 'white',
                              animation: 'pulse 2s infinite'
                            }} />
                            LIVE
                          </span>
                        )}
                      </div>
                      
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '12px'
                      }}>
                        <img
                          src={room.host?.avatar_url || `https://api.dicebear.com/7.x/initials/svg?seed=${room.host?.username}`}
                          alt={room.host?.username}
                          style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%'
                          }}
                        />
                        <span style={{ fontSize: '12px', color: '#888' }}>
                          Hosted by {room.host?.username}
                        </span>
                      </div>

                      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          fontSize: '12px',
                          color: '#888'
                        }}>
                          <Users size={12} style={{ color: '#00d4aa' }} />
                          {room.participant_count || 0}/{room.max_participants}
                        </div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          fontSize: '12px',
                          color: '#888'
                        }}>
                          <Eye size={12} style={{ color: '#8b5cf6' }} />
                          {room.viewer_count || 0}
                        </div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          fontSize: '12px',
                          color: '#888'
                        }}>
                          <MessageCircle size={12} style={{ color: '#f59e0b' }} />
                          {room.message_count || 0}
                        </div>
                      </div>

                      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                        <span style={{
                          padding: '4px 8px',
                          background: '#333',
                          borderRadius: '6px',
                          fontSize: '11px',
                          color: '#00d4aa',
                          fontWeight: '500'
                        }}>
                          {room.category || 'General'}
                        </span>
                        {room.strain && (
                          <span style={{
                            padding: '4px 8px',
                            background: '#333',
                            borderRadius: '6px',
                            fontSize: '11px',
                            color: '#10b981',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}>
                            <Leaf size={10} />
                            {room.strain}
                          </span>
                        )}
                      </div>

                      <div style={{ display: 'flex', gap: '12px' }}>
                        <button
                          onClick={() => handleInvitationAction(room, 'accept')}
                          disabled={processingRoomId === room.id}
                          style={{
                            flex: 1,
                            padding: '12px 20px',
                            background: processingRoomId === room.id ? '#666' : 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                            border: 'none',
                            borderRadius: '12px',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: processingRoomId === room.id ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {processingRoomId === room.id ? (
                            <>
                              <div style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid transparent',
                                borderTop: '2px solid white',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                              }} />
                              Processing...
                            </>
                          ) : (
                            <>
                              <Check size={16} />
                              Accept Invitation
                            </>
                          )}
                        </button>
                        
                        <button
                          onClick={() => handleInvitationAction(room, 'decline')}
                          disabled={processingRoomId === room.id}
                          style={{
                            flex: 1,
                            padding: '12px 20px',
                            background: processingRoomId === room.id ? '#666' : '#ef4444',
                            border: 'none',
                            borderRadius: '12px',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: processingRoomId === room.id ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {processingRoomId === room.id ? (
                            <>
                              <div style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid transparent',
                                borderTop: '2px solid white',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                              }} />
                              Processing...
                            </>
                          ) : (
                            <>
                              <X size={16} />
                              Decline
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
      `}</style>
    </div>
  );
};